import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { TranslationType, FormValues } from "../types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Control } from "react-hook-form";
import { useMarket } from "@/hooks/useMarket";
import { getLanguagesForMarket } from "@/config/market";
import { BookingLanguage } from "@/types/booking";

interface LanguageFieldProps {
  control: Control<FormValues>;
  t: TranslationType;
}

// Native endonym for each preferred-language option.
const LANGUAGE_LABELS: Record<BookingLanguage, string> = {
  "en-US": "English",
  "de-DE": "Deutsch",
  "fr-FR": "Français",
  "nl-NL": "Nederlands",
};

export const LanguageField = ({ control, t }: LanguageFieldProps) => {
  const { market } = useMarket();
  // Only offer the languages the active market actually serves.
  const languages = getLanguagesForMarket(market);
  return (
    <FormField
      control={control}
      name="preferredLanguage"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t.preferredLanguage}</FormLabel>
          <FormControl>
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger className="font-sans normal-case">
                <SelectValue placeholder={t.selectLanguage} />
              </SelectTrigger>
              <SelectContent>
                {languages.map((lang) => (
                  <SelectItem key={lang} value={lang}>
                    {LANGUAGE_LABELS[lang]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
